import * as Vuex from "vuex";
import JWS from "jws";
import { RootState, App } from "@/store/types";
import api from "../api";
type State = App;

const state: State = {
  token: ""
};

const getters: Vuex.GetterTree<State, RootState> = {
  token: (state): string | undefined => {
    if (!state.token) {
      return;
    }

    const exp = JWS.decode(state.token).payload.exp as number;
    const now = Date.now() / 1000;

    if (exp < now) {
      return;
    }

    return state.token;
  },
  login: (state, getters) => !!getters["token"]
};

const actions: Vuex.ActionTree<State, RootState> = {
  async login(
    { commit },
    payload: { company: string; username: string; password: string }
  ) {
    const result = await api.post("/token", {
      company: payload.company,
      id: payload.username,
      password: payload.password
    });
    commit("SET_TOKEN", result.data.jwt);
  },
  logout({ commit }) {
    commit("SET_TOKEN", "");
  }
};

const mutations: Vuex.MutationTree<State> = {
  SET_TOKEN(state, token: string) {
    state.token = token;
  }
};

export const app: Vuex.Module<State, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default app;
